<template>
  <ul class="x-tab">
    <li
      @click="tabClick(item.value,index)"
      v-for="(item, index) in data"
      :key="index"
      :class="{ active: tabActiveIndex === index }"
    >
      {{ item.label }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'x-tab',
  props: {
    data: {
      type: Array,
      default: () => [
        { label: '选项1', value: 1 },
        { label: '选项2', value: 2 }
      ]
    }
  },
  data() {
    return {
      tabActiveIndex: 0
    }
  },
  methods: {
    tabClick(val,i) {
      this.tabActiveIndex = i
      this.$emit('input',val)
      this.$emit('change',val)
    }
  }
}
</script>
 
<style lang="less" scoped>
:root{
  --theme-color:#496DDD;
}
.x-tab {
  display: flex;
  height: 66px;
  border-bottom: 1px solid #e9e9e9;
  li{
    position: relative;
    height: 66px;
    line-height: 66px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    color: #333333;
    margin: 0 30px;
  }
  .active {
    color: var(--theme-color);
    font-weight: bold;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      background: var(--theme-color);
      box-shadow: 0px 2px 24px 0px rgba(29, 66, 188, 0.28), 1px 1px 3px 0px #b8c0d4;
      bottom: 0px;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}
</style>